<template>
  <div class="agent-marketplace">
    <!-- 智能体内容区 -->
    <div class="agent-content">
      <!-- 标题和搜索区域 -->
      <div class="header-section">
        <div class="search-controls">
          <div class="search-bar">
            <el-input v-model="searchKeyword" placeholder="搜索智能体名称或描述" prefix-icon="el-icon-search"
              @input="handleSearch" clearable size="medium" />
          </div>
          <div class="sort-controls">
            <el-button icon="el-icon-search" size="medium" @click="refreshData">搜索</el-button>
          </div>
        </div>
      </div>

      <!-- 智能体列表 -->
      <div class="agent-container">
        <div class="agent-nav">
          <div class="nav-header">
            <span class="nav-title">分类</span>
          </div>
          <div class="nav-list">
            <div class="nav-item" :class="{ active: currentCategoryIndex === index }"
              v-for="(category, index) in categoryList" :key="category.guid" @click="switchCategory(index)">
              <div class="category-name">{{ category.categoryName }}</div>
              <div class="category-count">{{ category.agentCount }}</div>
            </div>
          </div>
        </div>

        <div class="agent-list" v-loading="loading">
          <!-- 调试信息 -->
          <div v-if="$store.state.debug" class="debug-info"
            style="background: #f0f0f0; padding: 10px; margin-bottom: 10px; font-size: 12px;">
            <p>当前分类索引: {{ currentCategoryIndex }}</p>
            <p>分类数据数组长度: {{ categoryAgentData.length }}</p>
            <p>当前智能体列表长度: {{ currentAgentList.length }}</p>
            <p>加载状态: {{ loading }}</p>
          </div>

          <div class="agent-grid">
            <div v-for="agent in currentAgentList" :key="agent.guid" class="agent-card">
              <!-- 智能体头像和状态 -->
              <div class="agent-avatar">
                <img :src="agent.agentAvatar || defaultAvatar" :alt="agent.agentName" />
                <!-- <div class="agent-type-badge">{{ agent.agentTypeText }}</div> -->
              </div>

              <!-- 智能体信息 -->
              <div class="agent-info">
                <h3 class="agent-name">{{ agent.agentName }}</h3>
                <p class="agent-description">{{ agent.agentDesc }}</p>

                <!-- 统计信息 -->
                <div class="agent-stats">
                  <span class="stat-item">
                    <i class="el-icon-view"></i>
                    {{ agent.stats.viewCountText }}
                  </span>
                  <span class="stat-item">
                    <i class="el-icon-star-on"></i>
                    {{ agent.stats.subscriberCountText }}
                  </span>
                </div>

                <!-- 创作者信息 -->
                <div class="creator-info">
                  <img :src="agent.creator.avatar" :alt="agent.creator.nickname" class="creator-avatar" />
                  <span class="creator-name">{{ agent.creator.nickname }}</span>
                </div>

                <!-- 价格信息 -->
                <div class="agent-price">
                  <div v-if="agent.isShowPrice" class="price-content">
                    <div class="price-main">
                      <span class="price-amount">{{ agent.priceYuan }}</span>
                      <span class="price-unit">元/月</span>
                    </div>
                    <div class="trial-info">
                      <i class="el-icon-present"></i>
                      <span>试用{{ agent.trialChatCount }}次</span>
                    </div>
                  </div>
                  <!-- <div v-else class="price-content free-content">
                    <div class="price-main">
                      <span class="price-amount free">免费</span>
                    </div>
                    <div class="trial-info">
                      <i class="el-icon-check"></i>
                      <span>无限使用</span>
                    </div>
                  </div> -->
                </div>
              </div>

              <!-- 操作按钮 -->
              <div class="agent-actions">
                <el-button v-if="!agent.isSubscribed" type="primary" size="small" @click.stop="subscribeAgent(agent)">
                  去招募
                </el-button>
                <el-button v-else type="success" size="small" @click.stop="selectAgent(agent)">
                  已合伙
                </el-button>
              </div>
            </div>
          </div>

          <!-- 空状态 -->
          <div v-if="currentAgentList.length === 0 && !loading" class="empty-state">
            <i class="el-icon-box"></i>
            <p>暂无智能体</p>
            <span>该分类下还没有智能体，敬请期待</span>
          </div>

          <!-- 分页 -->
          <div v-if="pagination.total > 0" class="pagination-wrapper">
            <el-pagination @current-change="handlePageChange" :current-page="pagination.current_page"
              :page-size="pagination.per_page" :total="pagination.total" layout="prev, pager, next, jumper" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getAgentListApi,
  getCategoryListApi,
  subscribeAgentApi
} from '@/apis/agent'

export default {
  name: 'agent-marketplace',

  data() {
    return {
      loading: false,
      searchKeyword: '',
      defaultAvatar: 'https://ai-v2.deepcity.cn/default/head.png',



      // 分类相关
      categoryList: [],
      currentCategoryIndex: 0,
      categoryAgentData: [],

      // 分页相关
      pagination: {
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 1
      },



      merchantGuid: this.$store.state.merchantGuid
    }
  },

  computed: {
    currentAgentList() {
      console.log('计算currentAgentList:', {
        currentCategoryIndex: this.currentCategoryIndex,
        categoryAgentDataLength: this.categoryAgentData.length,
        categoryAgentData: this.categoryAgentData
      })

      const currentData = this.categoryAgentData[this.currentCategoryIndex]
      console.log('当前分类数据:', currentData)

      if (!currentData || !currentData.data) {
        console.log('没有数据或数据格式不正确')
        return []
      }

      let result = [...currentData.data]
      console.log('原始数据长度:', result.length)

      // 搜索过滤
      if (this.searchKeyword) {
        result = result.filter(agent =>
          agent.agentName.toLowerCase().includes(this.searchKeyword.toLowerCase()) ||
          agent.agentDesc.toLowerCase().includes(this.searchKeyword.toLowerCase())
        )
        console.log('搜索过滤后长度:', result.length)
      }

      console.log('最终返回数据:', result)
      return result
    }
  },

  async mounted() {
    await this.initData()
  },

  methods: {
    // 初始化数据
    async initData() {
      await this.getCategoryList()
      if (this.categoryList.length > 0) {
        await this.getAgentList(0)
      }
    },

    // 获取分类列表
    async getCategoryList() {
      try {
        this.loading = true
        const res = await getCategoryListApi({
          merchantGuid: this.merchantGuid
        })

        if (res && res.data) {
          this.categoryList = res.data
          // 初始化categoryAgentData数组，填充null值确保响应式
          this.categoryAgentData = new Array(this.categoryList.length).fill(null)

          console.log('分类列表加载成功:', {
            categoryCount: this.categoryList.length,
            categories: this.categoryList.map(c => c.categoryName)
          })
        }
      } catch (error) {
        console.error('获取分类列表失败:', error)
        this.$message.error('获取分类列表失败')
      } finally {
        this.loading = false
      }
    },

    // 获取智能体列表
    async getAgentList(categoryIndex = null, page = 1) {
      if (this.categoryList.length === 0) return

      try {
        this.loading = true
        const targetIndex = categoryIndex !== null ? categoryIndex : this.currentCategoryIndex
        const category = this.categoryList[targetIndex]

        if (!category) return

        const res = await getAgentListApi({
          merchantGuid: this.merchantGuid,
          categoryGuid: category.guid,
          pageSize: this.pagination.per_page,
          page: page
        })

        if (res && res.data) {
          // 确保数组有足够的长度并使用Vue.set确保响应式
          while (this.categoryAgentData.length <= targetIndex) {
            this.categoryAgentData.push(null)
          }

          // 使用Vue.set确保响应式更新
          this.$set(this.categoryAgentData, targetIndex, res.data)

          // 更新分页信息
          this.pagination = {
            current_page: res.data.current_page || 1,
            per_page: res.data.per_page || 10,
            total: res.data.total || 0,
            last_page: res.data.last_page || 1
          }

          console.log('数据加载成功:', {
            targetIndex,
            dataLength: res.data.data ? res.data.data.length : 0,
            categoryAgentData: this.categoryAgentData
          })
        }
      } catch (error) {
        console.error('获取智能体列表失败:', error)
        this.$message.error('获取智能体列表失败')
      } finally {
        this.loading = false
      }
    },

    // 切换分类
    async switchCategory(index) {
      if (index === this.currentCategoryIndex) return

      this.currentCategoryIndex = index
      this.pagination.current_page = 1

      // 如果该分类数据未加载，则加载
      if (!this.categoryAgentData[index]) {
        await this.getAgentList(index)
      }
    },

    // 搜索处理
    handleSearch() {
      // 搜索逻辑已在computed中处理，这里可以添加防抖等优化
    },

    // 排序处理
    handleSort() {
      // 排序逻辑已在computed中处理
    },

    // 刷新数据
    async refreshData() {
      this.categoryAgentData = []
      await this.initData()
    },

    // 分页处理
    async handlePageChange(page) {
      this.pagination.current_page = page
      await this.getAgentList(this.currentCategoryIndex, page)
    },

    // 订阅智能体
    async subscribeAgent(agent) {
      try {
        const res = await subscribeAgentApi({
          merchantGuid: this.merchantGuid,
          agentGuid: agent.guid
        })

        if (res && res.code === 0) {
          // 更新本地状态
          agent.isSubscribed = true
          this.$message.success('订阅成功')
          // this.$emit('agent-subscribed', agent)
        } else {
          this.$message.error(res.msg || '订阅失败')
        }
      } catch (error) {
        console.error('订阅智能体失败:', error)
        this.$message.error('订阅失败，请稍后重试')
      }
    },

    // 选择智能体
    selectAgent(agent) {
      this.$emit('select-agent', agent)
    },


  }
}
</script>

<style lang="scss" scoped>
.agent-marketplace {
  height: 100%;
  display: flex;
  flex-direction: column;
  // background: #f8f9fa;

  // 智能体内容区样式
  .agent-content {
    flex: 1;
    overflow-y: auto;
  }

  .header-section {
    background: white;
    padding: 16px;
    border-bottom: 1px solid #e8e8e8;

    .search-controls {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 12px;

      .search-bar {
        flex: 1;
        max-width: 300px;

        .el-input {
          width: 100%;

          ::v-deep .el-input__inner {
            height: 32px;
            font-size: 13px;
          }
        }
      }

      .sort-controls {
        display: flex;
        gap: 8px;
        align-items: center;

        .el-button {
          height: 32px;
          padding: 0 12px;
          font-size: 13px;
        }
      }
    }
  }

  .agent-container {
    display: flex;
    // gap: 24px;
    flex: 1;
  }

  .agent-nav {
    width: 160px;
    background: white;
    border-radius: 8px;
    border: 1px solid #e8e8e8;
    height: fit-content;
    padding: 12px;
    margin-top: 16px;

    .nav-header {
      padding-bottom: 8px;

      .nav-title {
        font-size: 13px;
        color: #333;
        font-weight: 500;
      }
    }

    .nav-list {
      .nav-item {
        padding: 6px 8px;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 6px;
        margin-bottom: 2px;

        &:last-child {
          border-bottom: none;
        }

        &:hover {
          background: #f8f9fa;
        }

        &.active {
          background: #7848f1;
          color: white;

          .category-count {
            background: rgba(255, 255, 255, 0.2);
            color: white;
          }
        }

        .category-name {
          font-size: 12px;
          color: #333;
        }

        .category-count {
          font-size: 11px;
          color: #999;
          background: #f0f0f0;
          padding: 1px 4px;
          border-radius: 8px;
          min-width: 16px;
          text-align: center;
          line-height: 1.2;
        }

        &.active .category-name {
          color: white;
        }
      }
    }
  }

  .agent-list {
    flex: 1;
    background: transparent;
    overflow-y: auto;
    padding: 16px 12px;

    .agent-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
      gap: 12px;
      margin-bottom: 16px;
    }

    .agent-card {
      background: white;
      border-radius: 8px;
      padding: 16px;
      cursor: pointer;
      transition: all 0.3s ease;
      border: 1px solid #f0f0f0;

      &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        transform: translateY(-1px);
      }

      .agent-avatar {
        position: relative;
        text-align: center;
        margin-bottom: 12px;

        img {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid #f0f0f0;
        }

        .agent-type-badge {
          position: absolute;
          top: -6px;
          right: calc(50% - 36px);
          background: linear-gradient(135deg, #7848f1, #9c6bff);
          color: white;
          padding: 2px 6px;
          border-radius: 8px;
          font-size: 9px;
          font-weight: 500;
          white-space: nowrap;
        }
      }

      .agent-info {
        .agent-name {
          font-size: 15px;
          font-weight: 600;
          margin: 0 0 6px 0;
          color: #333;
          text-align: center;
          line-height: 1.3;
        }

        .agent-description {
          font-size: 12px;
          color: #666;
          line-height: 1.4;
          margin: 0 0 12px 0;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-align: center;
          min-height: 32px;
        }

        .agent-stats {
          display: flex;
          justify-content: center;
          gap: 12px;
          margin-bottom: 12px;
          font-size: 11px;

          .stat-item {
            display: flex;
            align-items: center;
            color: #999;

            i {
              margin-right: 2px;
              font-size: 12px;
            }
          }
        }

        .creator-info {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          margin-bottom: 12px;
          padding: 4px 8px;
          background: #f8f9fa;
          border-radius: 12px;

          .creator-avatar {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            object-fit: cover;
          }

          .creator-name {
            font-size: 11px;
            color: #666;
            font-weight: 500;
          }
        }

        .agent-price {
          border-radius: 6px;
          padding: 8px;
          margin-bottom: 12px;
          text-align: center;
          min-height: 48px;
          display: flex;
          align-items: center;
          justify-content: center;

          .price-content {
            width: 100%;

            &:not(.free-content) {
              background: linear-gradient(135deg, #f8f9ff 0%, #e8f4fd 100%);
              border: 1px solid #e1e8f0;
              border-radius: 6px;
              padding: 6px;
            }

            &.free-content {
              background: linear-gradient(135deg, #f6ffed 0%, #e6f7ff 100%);
              border: 1px solid #b7eb8f;
              border-radius: 6px;
              padding: 6px;
            }
          }

          .price-main {
            display: flex;
            align-items: baseline;
            justify-content: center;
            gap: 2px;
            margin-bottom: 4px;

            .price-amount {
              font-size: 18px;
              font-weight: 700;
              color: #7848f1;
              line-height: 1;

              &.free {
                color: #52c41a;
                font-size: 16px;
              }
            }

            .price-unit {
              font-size: 11px;
              color: #666;
              font-weight: 500;
            }
          }

          .trial-info {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 2px;
            font-size: 10px;
            color: #52c41a;
            font-weight: 500;

            i {
              font-size: 11px;
            }
          }
        }
      }

      .agent-actions {
        text-align: center;

        .el-button {
          width: 100%;
          height: 32px;
          border-radius: 16px;
          font-weight: 500;
          font-size: 12px;

          &.el-button--primary {
            background: linear-gradient(135deg, #7848f1, #9c6bff);
            border: none;

            &:hover {
              background: linear-gradient(135deg, #6a3de8, #8b5cf6);
            }
          }

          &.el-button--success {
            background: #52c41a;
            border-color: #52c41a;

            &:hover {
              background: #73d13d;
              border-color: #73d13d;
            }
          }
        }
      }
    }

    .empty-state {
      text-align: center;
      padding: 80px 20px;
      color: #999;

      i {
        font-size: 64px;
        margin-bottom: 16px;
        display: block;
        color: #d9d9d9;
      }

      p {
        font-size: 18px;
        margin: 0 0 8px 0;
        color: #666;
        font-weight: 500;
      }

      span {
        font-size: 14px;
        color: #999;
      }
    }

    .pagination-wrapper {
      display: flex;
      justify-content: center;
      padding: 24px 0;
      border-top: 1px solid #f0f0f0;
      margin-top: 24px;
    }
  }
}



// 响应式设计 - 优化小屏体验
@media (max-width: 1200px) {
  .agent-marketplace {
    .agent-container {
      padding: 12px 16px;
    }

    .agent-nav {
      width: 140px;
    }

    .agent-list .agent-grid {
      grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
      gap: 10px;
    }
  }
}

@media (max-width: 768px) {
  .agent-marketplace {
    .tab-container .tab-bar {
      padding: 0 12px;

      .tab {
        padding: 10px 0;

        .tab-text {
          font-size: 13px;
        }
      }
    }

    .header-section {
      padding: 12px;

      .search-controls {
        flex-direction: column;
        gap: 8px;

        .search-bar {
          max-width: none;
        }
      }
    }

    .agent-container {
      flex-direction: column;
    }

    .agent-nav {
      width: 100%;
      margin-top: 8px;
      padding: 8px;

      .nav-list {
        display: flex;
        overflow-x: auto;
        gap: 4px;

        .nav-item {
          flex-shrink: 0;
          min-width: 80px;
          padding: 4px 6px;
          margin-bottom: 0;
          border-radius: 4px;

          .category-name {
            font-size: 11px;
          }

          .category-count {
            font-size: 10px;
            padding: 1px 3px;
          }
        }
      }
    }

    .agent-list {
      padding: 8px;

      .agent-grid {
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
        gap: 8px;
      }

      .agent-card {
        padding: 12px;

        .agent-avatar img {
          width: 40px;
          height: 40px;
        }

        .agent-info {
          .agent-name {
            font-size: 14px;
          }

          .agent-description {
            font-size: 11px;
            min-height: 28px;
          }
        }
      }
    }
  }
}
</style>
